export default function initListFilter(el) {
  const listItems = document.querySelectorAll('.exercise-item');
  const groupItems = document.querySelectorAll('.zone-group');
  const inputEl = el.querySelector('input');

  if (!inputEl) return;

  inputEl.addEventListener('input', (e) => {
    const term = e.target.value.toLowerCase().trim();
    
    listItems.forEach(item => {
      const name = item.getAttribute('data-name') || '';
      if (name.includes(term)) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
    });

    groupItems.forEach(group => {
      const visibleItems = group.querySelectorAll('.exercise-item[style="display: flex;"]');
      if (term === '') {
        group.style.display = 'block';
      } else {
        group.style.display = visibleItems.length > 0 ? 'block' : 'none';
      }
    });
  });
}
